import type { ReactNode } from 'react'

import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'

export const AgencyDetailLoading = (): ReactNode => (
  <div className="agency-detail-wrapper flex h-full flex-col">
    <div className="p-6 space-y-6 max-w-4xl">
      <div className="space-y-4">
        <Skeleton className="h-8 w-24" />
        <div className="flex items-start gap-4">
          <Skeleton className="size-16 rounded-lg" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-8 w-64" />
            <Skeleton className="h-5 w-32" />
          </div>
        </div>
        <Skeleton className="h-20 w-full" />
      </div>
      <Separator />
      <Skeleton className="h-32 w-full rounded-lg" />
    </div>
  </div>
)
